import React from "react";
import { Box, Typography } from "@mui/material";
import { COLOR_MAP } from "../../../../../constants/ColorNames";
import { ICampaignSenderDetails } from "../../../../../types/campaign.types";

interface IProps {
  senderDetails: ICampaignSenderDetails;
}

const SenderInfo: React.FC<IProps> = ({ senderDetails }) => {
  return (
    <Box
      sx={{
        backgroundColor: COLOR_MAP.WHITE,
        display: "flex",
        p: 2,
        mb: 0.5,
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      }}
      columnGap={1}
    >
      <Typography variant="h6" sx={{ color: COLOR_MAP.GREY_3 }}>
        From:{" "}
      </Typography>

      <Box sx={{ display: "flex" }}>
        <Typography variant="h6" sx={{ fontWeight: "fontWeightBold", mr: 1 }}>
          {senderDetails.number ? "+" : ""} {senderDetails.countryCode}{" "}
          {senderDetails.number}
        </Typography>
        <Typography
          variant="h6"
          sx={{ color: COLOR_MAP.GREY_3, textTransform: "lowercase" }}
        >
          {senderDetails?.name ? `(${senderDetails?.name || ""})` : ""}
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(SenderInfo);
